"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCorrectSuffix = void 0;
var valueIsPositive = function (pounds) { return !pounds.startsWith('-'); };
var useCorrectSuffix = function (creditType, amount) {
    switch (creditType) {
        case 'payment':
            return valueIsPositive(amount) ? 'in' : 'out';
        case 'charge':
            return valueIsPositive(amount) ? 'out' : 'in';
        case 'balance':
            return valueIsPositive(amount) ? 'in credit' : 'in debit';
        default:
            return '';
    }
};
exports.useCorrectSuffix = useCorrectSuffix;
